import { render, staticRenderFns } from "./LiveOrderToast.vue?vue&type=template&id=63697834&scoped=true"
import script from "./LiveOrderToast.vue?vue&type=script&lang=js"
export * from "./LiveOrderToast.vue?vue&type=script&lang=js"
import style0 from "./LiveOrderToast.vue?vue&type=style&index=0&id=63697834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63697834",
  null
  
)

export default component.exports